import script from "./DiagnosisTabularList.vue?vue&type=script&lang=ts&setup=true"
export * from "./DiagnosisTabularList.vue?vue&type=script&lang=ts&setup=true"

import "./DiagnosisTabularList.vue?vue&type=style&index=0&id=2b500d3c&lang=scss"

const __exports__ = script;

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QTooltip,QChip});
